import React from "react";

const Table = ({ title, headings, data, onEdit, onDelete, error }) => {
  return (
    <div className="overflow-x-auto">
      <h1 className="text-sm font-bold text-gray-700 w-fit mb-4 p-2 rounded-lg">
        {title}
      </h1>
      {data && data.length > 0 ? (
        <table className="min-w-full text-xs bg-white rounded-lg">
          <thead className="bg-orange-100">
            <tr>
              {headings.map((heading, index) => (
                <th
                  key={index}
                  className={`py-2 px-4 ${index === 0 ? "rounded-tl-lg" : ""}`}
                >
                  {heading}
                </th>
              ))}
              <th className="rounded-tr-lg">Action</th>
            </tr>
          </thead>
          <tbody className="border-b-2 border-x-2">
            {data.map((item, rowIndex) => (
              <tr key={item.id} className="text-center">
                <td className="py-2 px-4">{rowIndex + 1}.</td>
                <td className="py-2 px-4">{item.name || item.userName}</td>

                {item.roles ? (
                  <td className="py-2 px-4">{item.roles[0]}</td>
                ) : (
                  <td className="py-2 px-4">{item.email}</td>
                ) }
                <td className="py-2 px-4 flex- flex-row">
                  <button
                    className="w-fit border-2 rounded-full p-1 mx-2"
                    onClick={() => onEdit(item)}
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M4.16634 13.3333L3.33301 16.6667L6.66634 15.8333L16.3213 6.17835C16.6338 5.8658 16.8093 5.44195 16.8093 5.00001C16.8093 4.55807 16.6338 4.13423 16.3213 3.82168L16.178 3.67835C15.8655 3.36589 15.4416 3.19037 14.9997 3.19037C14.5577 3.19037 14.1339 3.36589 13.8213 3.67835L4.16634 13.3333Z"
                        stroke="#808797"
                        strokeWidth="2.08333"
                        strokeLinecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M4.16634 13.3333L3.33301 16.6667L6.66634 15.8333L14.9997 7.5L12.4997 5L4.16634 13.3333Z"
                        fill="#808797"
                      />
                      <path
                        d="M12.4997 5L14.9997 7.5M10.833 16.6667H17.4997"
                        stroke="#808797"
                        strokeWidth="2.08333"
                        strokeLinecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </button>
                  <button
                    className="w-fit border-2 rounded-full p-1 mx-2"
                    onClick={() => onDelete(item.id)}
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M5.00033 15.8333C5.00033 16.75 5.75033 17.5 6.66699 17.5H13.3337C14.2503 17.5 15.0003 16.75 15.0003 15.8333V7.5C15.0003 6.58333 14.2503 5.83333 13.3337 5.83333H6.66699C5.75033 5.83333 5.00033 6.58333 5.00033 7.5V15.8333ZM15.0003 3.33333H12.917L12.3253 2.74167C12.1753 2.59167 11.9587 2.5 11.742 2.5H8.25866C8.04199 2.5 7.82533 2.59167 7.67533 2.74167L7.08366 3.33333H5.00033C4.54199 3.33333 4.16699 3.70833 4.16699 4.16667C4.16699 4.625 4.54199 5 5.00033 5H15.0003C15.4587 5 15.8337 4.625 15.8337 4.16667C15.8337 3.70833 15.4587 3.33333 15.0003 3.33333Z"
                        fill="#E31F1F"
                      />
                    </svg>
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <div className="text-center p-4">No recipients available</div>
      )}
      {error && <div className="text-red-500 mt-2">{error}</div>}
    </div>
  );
};

export default Table;
